import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "SettingPage gap-md column no-wrap row-sm items-sm-center justify-between q-pt-20 q-pt-md-lg q-mb-12" }
const _hoisted_2 = { class: "row items-center gap-12" }
const _hoisted_3 = {
  key: 1,
  class: "row items-center"
}
const _hoisted_4 = { class: "fs-17px fw-500 text-cool-gray-100" }
const _hoisted_5 = { class: "q-pt-sm" }

import type { IBaseOverlay, ICalloutProps } from 'src/common/interfaces'
import { inject, Ref } from 'vue'

interface IProps {
  title: string
  buttonLabel?: string
  buttonEvent?: string
  callout?: ICalloutProps
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'SettingPage' },
  __name: 'SettingPage',
  props: {
    title: {},
    buttonLabel: { default: 'Add' },
    buttonEvent: { default: '' },
    callout: { default: () => ({}) as ICalloutProps }
  },
  setup(__props: any) {




const settingsOverlay = inject<{ overlay: Ref<IBaseOverlay>; title: string } | null>('settings-overlay')

return (_ctx: any,_cache: any) => {
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_k_callout = _resolveComponent("k-callout")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page__page q-px-md q-px-md-lg q-px-lg-none q-ml-lg-56 q-pb-80", { 'float-left': _ctx.$q.screen.gt.md }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$q.screen.lt.lg && _unref(settingsOverlay))
          ? (_openBlock(), _createBlock(_component_k_btn, {
              key: 0,
              model: "secondary",
              size: "md",
              icon: "hamburger-menu",
              "is-right-icon": "",
              label: _unref(settingsOverlay).title || '',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(settingsOverlay).overlay.value.show()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_ctx.$slots['header'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
              (__props.callout.title || __props.callout.description)
                ? (_openBlock(), _createBlock(_component_k_callout, _mergeProps({ key: 0 }, __props.callout, { "container-class": "q-ml-xs" }), null, 16))
                : _createCommentVNode("", true)
            ]))
          : _renderSlot(_ctx.$slots, "header", { key: 2 })
      ]),
      (__props.buttonLabel && __props.buttonEvent)
        ? (_openBlock(), _createBlock(_component_k_btn, {
            key: 0,
            model: "secondary",
            label: __props.buttonLabel,
            size: "md",
            icon: "plus-rounded",
            "is-right-icon": "",
            "icon-size": "32px",
            padding: "8px 20px 8px 8px",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(__props.buttonEvent)))
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})